import { ViewMode } from '../constants/enums'
import { TransitionTypes } from '../state'
import { setRoomViewMode } from '../state/internal/rooms'
import type { VideoViewModeHandlers } from '../state/internal/videoViewModeControls'
import { motionTransition } from '../utilities/transitions'

/**
 * The SDK button actions. setupSubscriptions registers them, and the wrappers
 * state.video spreads into each Player's options look them up per click
 * (internal/videoViewModeControls). Imported into state.video instead, they
 * would pull the router and the component tree, which import state.video
 * back, into its module graph. The SDK has already flipped its toggle when
 * one runs; the layout the new mode renders sets it from its placeholder.
 */
export const videoViewModeHandlers = (id: number): VideoViewModeHandlers => {
    const change = (viewMode: ViewMode, saveSetting: boolean) =>
        motionTransition(() => setRoomViewMode(viewMode, saveSetting), {
            id,
            transitionSource: TransitionTypes.ROOM,
            transitionDestination: TransitionTypes.ROOM,
        })
    return {
        // the full-window button saves the auto-full-window setting both
        // ways (setFullWindow); the chat-overlay button never touches it
        theaterModeHandler: (fullWindow: boolean) =>
            change(fullWindow ? ViewMode.FullWindow : ViewMode.Normal, true),
        chatOverlayHandler: (theater: boolean) =>
            change(theater ? ViewMode.Theater : ViewMode.Normal, false),
    }
}
